export const plGridLocales = {
  columnMenuSortAsc: "Sortuj rosnąco",
  columnMenuSortDesc: "Sortuj malejąco",
  pinToLeft: "Przypnij do lewej",
  pinToRight: "Przypnij do prawej",
  columnMenuFilter: "Filtruj",
  columnMenuHideColumn: "Ukryj kolumnę",
  columnMenuShowColumns: "Pokaż kolumnę",
  columnMenuManageColumns: "Zarządzaj kolumnami",
  columnMenuUnsort: "Wyłącz sortownie",
  columnsManagementNoColumns: "Odznacz wszystkie",
  columnMenuLabel: "Kolumny",
  toolbarColumns: "Kolumny",
  toolbarDensity: "Wiersze",
  toolbarFilters: "Filtry",
  toolbarDensityCompact: "Kompaktowy",
  toolbarDensityComfortable: "Wygodny",
  toolbarDensityStandard: "Standardowy",
  columnsManagementShowHideAllText: "Pokaż/ukryj wszystkie",
  columnsManagementSearchTitle: "Wyszukaj",
  toolbarQuickFilterDeleteIconLabel: "Usuń wszystkie",
  filterPanelAddFilter: "Dodaj filtr",
  filterPanelRemoveAll: "Usuń wszystkie",
  toolbarFiltersTooltipShow: "Pokaż filtry",
  toolbarFiltersTooltipHide: "Ukryj filtry",
  emptyPivotOverlayLabel: "Brak",
  aggregationFunctionLabelSize: "Ilość",
  groupColumn: (n) => `Grupuj ${n}`,
  unGroupColumn: (n) => `Rozgrupuj ${n}`,
  columnMenuManagePivot: "Zarządzaj trybem pivot",
  aggregationFunctionLabelSum: "Suma",
};
